<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item label="优惠码" prop="code">
        <a-input v-model="form.data.code" auto-focus/>
      </a-form-model-item>
      <!--      <a-form-model-item label="类型" prop="type">-->
      <!--        <a-radio-group v-model="form.data.type">-->
      <!--          <a-radio value="RATE">-->
      <!--            RATE-->
      <!--          </a-radio>-->
      <!--          <a-radio value="AMOUNT">-->
      <!--            AMOUNT-->
      <!--          </a-radio>-->
      <!--        </a-radio-group>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="固定折扣金额" v-if="form.data.type === 'AMOUNT'" prop="amount">-->
      <!--        <a-input v-model="form.data.amount"/>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item v-if="form.data.type === 'AMOUNT'" label="折扣金额货币代码">-->
      <!--        <a-input v-model="form.data.currencyCode"/>-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="x%off" prop="discount">
        <a-input v-model="form.data.discount"/>
      </a-form-model-item>
      <a-form-model-item label="过期时间(不填则长期有效)">
        <a-date-picker
          v-model="form.data.expireAt"
          show-time
          type="date"
          placeholder=""
          style="width: 100%;"/>
      </a-form-model-item>
      <a-form-model-item label="是否激活">
        <a-switch v-model="activeSwitch" @change="onActiveChange"/>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" v-if="!couponId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="couponId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { _addCoupon, _getCouponDetail, _updateCoupon } from '@/api/websiteCouponApi';

async function getCouponDetail() {
  const result = await _getCouponDetail(this.couponId);
  if (result) {
    this.form.data.code = result.code;
    this.form.data.isActive = result.isActive;
    this.form.data.discount = result.discount;
    this.form.data.expireAt = result.expireAt;
    this.activeSwitch = result.isActive === 'YES';
    // this.form.data.type = result.type;
    // this.form.data.amount = result.amount;
    // this.form.data.currencyCode = result.currencyCode;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addCoupon({
        code: this.form.data.code,
        discount: this.form.data.discount,
        expireAt: this.form.data.expireAt,
        isActive: this.form.data.isActive,
        // amount: this.form.data.amount,
        // type: this.form.data.type,
        // currencyCode: this.form.data.currencyCode,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateCoupon(this.couponId, {
        code: this.form.data.code,
        discount: this.form.data.discount,
        amount: this.form.data.amount,
        type: this.form.data.type,
        expireAt: this.form.data.expireAt,
        isActive: this.form.data.isActive,
        currencyCode: this.form.data.currencyCode,
      });
      if (result) {
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        if (this.onSubmitHandler) {
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function onActiveChange() {
  if (this.activeSwitch === true) {
    this.form.data.isActive = 'YES'
  } else {
    this.form.data.isActive = 'NO'
  }
}

export default {
  name: 'CouponWebsiteEdit',
  props: {
    couponId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  methods: {
    onAdd,
    onCancel,
    onUpdate,
    getCouponDetail,
    onActiveChange,
  },
  data() {
    return {
      activeSwitch: false,
      // discountType: {
      //   data: ['AMOUNT', 'RATE'],
      // },
      form: {
        data: {
          code: '',
          discount: '',
          type: 'AMOUNT',
          amount: '',
          currencyCode: '',
          expireAt: '',
          isActive: '',
        },
        rules: {
          code: [{ required: true, trigger: 'blur' }],
          discount: [{ required: true, trigger: 'blur' }],
          type: [{ required: true, trigger: 'blur' }],
          isActive: [{ required: true, trigger: 'blur' }],
          // amount: [{ required: true, trigger: 'blur' }],
          // currencyCode: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.couponId) {
      await this.getCouponDetail();
    }
  },
};
</script>
